/**
 * Shared constants for injection scripts
 */

export const SCRIPT_VERSION = '1.0.0';

export const DEFAULT_TIMEOUT = 5000; // 5 seconds

export const LOG_PREFIX = '[Injection Script]';

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
} as const;

export const isDevelopment = import.meta.env.DEV;
